import { render, staticRenderFns } from "./PosturesByPeriodModal.vue?vue&type=template&id=d2f91610"
import script from "./PosturesByPeriodModal.vue?vue&type=script&lang=js"
export * from "./PosturesByPeriodModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports